import { useMemo, useEffect, useState } from "react";

const useAuth = () => {
  const [user, setUser] = useState(null);
  const token = useMemo(() => localStorage.getItem("authToken"), []);

  const isAuthenticated = useMemo(() => !!token, [token]);

  useEffect(() => {
    if (isAuthenticated) {
      const userData = localStorage.getItem("user"); // assuming user info is stored
      if (userData) {
        setUser(JSON.parse(userData));
      } else {
        // Optionally, fetch user from API
        // axiosInstance.get('/auth/me').then(res => setUser(res.data));
      }
    }
  }, [isAuthenticated]);

  return {
    user,
    isAuthenticated,
  };
};

export default useAuth;
